








import Vue from "vue";
export interface BaseSingleSelect {
  value?: number;
  set: (value: number) => void;
}

interface Provide {
  getSingleSelectState: () => BaseSingleSelect;
}

export default Vue.extend({
  props: {
    value: {
      type: Number,
      required: false
    },
    label: {
      type: String,
      required: true
    }
  },
  provide(): Provide {
    return {
      getSingleSelectState: this.singleSelectState
    };
  },

  methods: {
    singleSelectState(): BaseSingleSelect {
      return {
        value: this.value,
        set: this.setValue
      };
    },
    setValue(value: number) {
      this.$emit("input", value);
    }
  }
});
